import { render } from "./ScanResult.vue?vue&type=template&id=2c1a557c&scoped=true"
import script from "./ScanResult.vue?vue&type=script&lang=js"
export * from "./ScanResult.vue?vue&type=script&lang=js"

import "./ScanResult.vue?vue&type=style&index=0&id=2c1a557c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c1a557c"]])

export default __exports__